const {loadScript, loadStyle} = require('./util/loadDependencies');
require('./util/foreach-polyfill');
// require('./util/ga-dev-fallback');

// Autocomplete
export default (jsBasePath) => jQuery(($) => {
	const triggerSearchSuggestions = () => {
		var xhr;
		var suggestionsSource = guided_links_ajax_vars.url;
		var wp_nonce = guided_links_ajax_vars.nonce;
		var wp_action = guided_links_ajax_vars.action;
		var wp_admin_edit = guided_links_ajax_vars.admin_edit || false;
		var lookups = $('.carleton-guided-links__field');

		lookups.each((idx) => {
			var lookupField = $(lookups[idx]);
			// var audiences = lookupField.attr('data-audiences');
			var context = lookupField.attr('data-context');
			var ous = lookupField.attr('data-ous');
			var map = lookupField.attr('data-map');

			lookupField.focus(function () {
				$(this).select();
				if ($(this).val().trim().length) $('.carleton-guided-links__search-results').show();
			});

			[
				{
					selector: lookups[idx],
					menuClass: 'carleton-guided-links__search-results',
				},
			].forEach((args) => {
				new autoComplete({
					selector: args.selector,
					menuClass: args.menuClass,
					delay: 300,
					source: function (term, response) {
						try {
							xhr.abort();
						} catch (e) {
						}
						xhr = $.getJSON(suggestionsSource,
							{
								partial: term,
								// audiences: audiences,
								context: context,
								action: wp_action,
								ous: ous,
								map: map,
								nonce: wp_nonce
							},
							function (data) {
								response(data.data || [{'noresults': true}]);
							}
						);
					},
					renderItem: function (item, search) {
						// escape special characters
						search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
						var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
						// return '<div class="autocomplete-suggestion" data-val="' + item.label.replace(/"/g, '&quot;') + '" data-url="' + item.url.replace(/"/g, '&quot;') + '">' + item.label.replace(re, "<b>$1</b>") + '</div>';
						return item.noresults ?
							'<div class="autocomplete-suggestion" data-url="https://www.carleton.edu/search/?q=' + search + '">Search Carleton for <b>' + search + '</b></div>' :
							'<div class="autocomplete-suggestion" data-val="' + item.label.replace(/"/g, '&quot;') + '" data-url="' + item.url.replace(/"/g, '&quot;') + '" title="' + item.label.replace(/"/g, '&quot;') + '">' + item.label.replace(re, "<b>$1</b>") + '</div>' +
							(wp_admin_edit ? '<a href="?edit-id=' + item.id + '" style="display: block; padding-left: 1em;">↳ EDIT: ' + item.label + '</a>' : '');
					},
					onSelect: function (e, term, item) {
						if (item.getAttribute('data-url').length) {
							e.preventDefault();
							var url = item.getAttribute('data-url');
							// url = url.replace(/^\//, baseURL);
							// ga('send', 'event', 'Homepage', 'Search', term);
							window.location.href = url;

							return false;
						}
					}
				});
			});
		});
	}

	loadScript(`${jsBasePath}./autoComplete/auto-complete.min.js`, triggerSearchSuggestions);
});
